import React, {useEffect, useRef, useState} from 'react';
import Header from "../Header";
import Footer from "../Footer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sendRequestQuduq} from "../../api/request";
import {ExcelPrint} from "../../units/Print";

const Barchasi = () => {
    const date = new Date()
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    const today = `${year}-${month}-${day}`

    const inputRef = useRef();
    const [datee, setDatee] = useState(today)
    const [loading, setLoading] = useState(false)
    const [dataAll, setDataAll] = useState([])
    const [dataone, setDataone] = useState(new Date().toLocaleString() + "")

    useEffect(() => {
        const GetAll = async () => {
            try {
                await sendRequestQuduq({
                    url: "dayver",
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setDataAll(res.data)
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetAll()
    }, []);

    return (
        <>
            <Header />
            <div className="container mt-4 mt-sm-5 _container">
                <div className="card py-3 mb-0" style={{backgroundColor: "#cfe2ff"}}>
                    <h3 className="text-center" style={{maxWidth: "900px", marginLeft: "auto", marginRight: "auto"}}>2021-2025-yillarda o‘rnatilgan "Dayver" qurilmalari to‘g‘risida ma'lumot (<span className="text-decoration-underline">data all {datee}</span>)</h3>
                </div>
            </div>
            <div className="mx-2">
                <div className="bgc"></div>
                <form>
                    <div className="mt-4 mt-xxl-0 mb-1 d-flex justify-content-start">
                        <input
                            readOnly
                            ref={inputRef}
                            type="date"
                            className="form-control"
                            style={{maxWidth: "200px", height: "30px"}}
                            value={datee}
                            onChange={() => setDatee(inputRef.current.value)}
                        />
                        <button  type="button" disabled className="py-0 ms-2 btn btn-info">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Qidirish
                        </button>
                        <button
                            type="button"
                            onClick={()=>ExcelPrint("Data ("+today+")", "dayver","tblData")}
                            className=" mt-2 mt-sm-0 btn btn-success py-0 ms-2 ms-auto">
                            <FontAwesomeIcon icon="fa-solid fa-file-excel" /> Excel
                        </button>
                    </div>
                </form>

                <table data-cols-width="5,30,14,14,28,35,8,12,12,12,20,8,15,10,10,13,14" className="mt-1 mt-xxl-0 table table-bordered table-hover text-center table-style" style={{fontSize: "12px"}} id="tblData">
                    <thead className="table-primary align-middle">
                    <tr data-height="20">
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">ST/ID</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Obyekt nomi</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Viloyat</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Tuman</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Balans tashkilot</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Pudratchi</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" className="d-none" scope="col">Protokol</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" className="d-none" scope="col">Lon</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" className="d-none" scope="col">Lat</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" className="d-none" scope="col">Simkarta</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Kadastr raqam</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Yil hisobi</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Integratsiya</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Level</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Mineral</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" className="d-none" scope="col">Temperatura</th>
                        <th data-f-sz="8" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">O'lchagan vaqt</th>
                    </tr>
                    </thead>
                    <tbody className="align-middle">
                    {
                        loading ?
                            dataAll.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" data-f-bold="true" data-t="n" scope="row">{item.id}</th>
                                        <td data-b-a-s="thin" data-a-v="middle" data-f-bold="true" data-f-sz="8" className="text-start">{item.obyekt}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.vil_nomi}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.tum_nomi}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.name}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.company}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" className="d-none">{item.protocol}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" className="d-none">{item.lon}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" className="d-none">{item.lat}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" className="d-none">{item.simkart}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.cadastr}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" data-t="n">{item.made}</td>
                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.created_at}</td>
                                        {/*<td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.level}</td>*/}
                                        {/*<td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.mineral}</td>*/}
                                        {/*<td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8" className="d-none">{item.temperatura}</td>*/}
                                        {
                                            item.level ?
                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" data-f-sz="8">{item.level}</td>
                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.level}</td>
                                        }
                                        {/*<td data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.level}</td>*/}
                                        {
                                            item.mineral ?
                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" data-f-sz="8">{item.mineral}</td>
                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.mineral}</td>
                                        }
                                        {/*<td data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.mineral}</td>*/}
                                        {
                                            item.temperatura ?
                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" className="d-none" data-f-sz="8">{item.temperatura}</td>
                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" className="d-none" data-f-sz="8">{item.temperatura}</td>
                                        }
                                        {
                                            item.sana ?
                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" data-num-fmt="0" data-f-sz="8">{item.sana}</td>
                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-sz="8">{item.sana}</td>
                                        }
                                        {/*<td>{item.sana}</td>*/}
                                    </tr>
                                )
                            }) : <tr><td colSpan={15}>Yuklanmoqda...</td></tr>
                    }
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
};

export default Barchasi;